import Vue from 'vue';
import VeeValidate, {Validator} from 'vee-validate';

const alwaysOk = (value) => true;

// The messages getter may also accept a third parameter that includes the data we returned earlier.
Validator.extend('ok', {
  validate: alwaysOk,
  getMessage: () => 'ok'
});

Vue.use(VeeValidate);
